import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup'

const cResetPasswordConfirm = yup
  .object()
  .shape({
    password: yup.string().required('Mot de passe obligatoire'),
    re_password: yup.string().required('Vérifier Mot de passe obligatoire'),
  })
  .required();
const ResetPasswordConfirmProvider = ({children}) => {
    const methods = useForm({
        values:{
            phone:'',
            password: ''        
        },
        defaultValues:{
            phone:'',
            password: ''        
        },
        resolver:yupResolver(cResetPasswordConfirm)
    })
  return (
    <FormProvider {...methods}>{children}</FormProvider>
  )
}

export default ResetPasswordConfirmProvider